import "./Carousel.css"
import CardDescription from "../card-description/CardDescription";
import LinkItem from "../links/LinkItem";
import { linkItems, url } from "../../utils/constants";
import { useTranslation } from "react-i18next";

const Carousel = () => {
  const { t } = useTranslation();

  const getTitle = (linkUrl?: string): string => {
    const titleMap: Record<string, string> = {
      [url.linkedin]: t("title.linkedin"),
      [url.gitlab]: t("title.gitlab"),
      [url.googlecloudskills]: t("title.googlecloudskills"),
      [url.hackerthebox]: t("title.hackthebox"),
      [url.github]: t("title.github"),
      [url.credly]: t("title.credly"),
    };
    return titleMap[linkUrl || ''] || '';
  };

  const getDescription = (linkUrl?: string): string => {
    const descMap: Record<string, string> = {
      [url.linkedin]: t("description.linkedin"),
      [url.gitlab]: t("description.gitlab"),
      [url.googlecloudskills]: t("description.googlecloudskills"),
      [url.hackerthebox]: t("description.hackthebox"),
      [url.github]: t("description.github"),
      [url.credly]: t("description.credly"),
    };
    return descMap[linkUrl || ''] || '';
  };

  return (
    <div className="flex flex-col gap-4 w-full">
      {linkItems.map((linkItem, index) => {
        const { icon, link_ } = linkItem;
        
        return (
          <div 
            key={link_} 
            className="container-item flex items-center gap-4 p-4 bg-white/60 backdrop-blur-sm rounded-2xl border border-white/50 shadow-sm hover:shadow-md transition-all duration-300 animate-fade-in"
            style={{ animationDelay: `${index * 80}ms` }}
          >
            <LinkItem icon={icon} link={link_} delay={index * 80} />
            <CardDescription
              title={getTitle(link_)}
              description={getDescription(link_)}
              url={link_}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Carousel;
